export async function sleep(time = 500) {
	return new Promise(resolve => {
		setTimeout((yolo) => resolve(), time)
	})
}


export function checkUserInteraction() {

	console.log('checkUserInteraction()...')

	const audioContext = new AudioContext()

	const stateSuspened = audioContext.state !== 'suspended'
	
	console.log('checkUserInteraction()...', stateSuspened)

	return stateSuspened

}